import React from "react";
import styled from "styled-components";
import { useMediaStudio } from "../../context/MediaStudioContext";
import { Card, CardTitle, CardHint, Muted, Row, RowList, Thumb, projectThumb } from "../shared";
import { BarDatum, compact } from "./homeDerive";

const ClickRow = styled(Row)`
  cursor: pointer;
  border-radius: var(--radius-sm);

  &:hover {
    background: var(--color-surface-subtle);
  }
`;

const Caption = styled.div`
  font-family: var(--font-sans);
  font-size: var(--font-size-sm);
  color: var(--color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export type TopPostsProps = {
  data: BarDatum[];
  onSelect: (postId: string) => void;
};

export const TopPosts: React.FC<TopPostsProps> = ({ data, onSelect }) => {
  const { projects } = useMediaStudio();
  if (data.length === 0) return null;
  return (
    <Card>
      <CardTitle>All-time top posts</CardTitle>
      <RowList>
        {data.map((d, i) => {
          const thumb =
            projectThumb(
              d.post.projectId
                ? projects.projectById.get(d.post.projectId)
                : undefined
            ) || d.post.mediaUrls[0];
          return (
            <ClickRow key={d.post.id} onClick={() => onSelect(d.post.id)}>
              <Muted style={{ minWidth: 14 }}>{i + 1}</Muted>
              {thumb ? <Thumb src={thumb} alt="" /> : null}
              <div style={{ minWidth: 0, flex: 1 }}>
                <Caption>{d.post.caption?.trim() || "Untitled post"}</Caption>
                <Muted>
                  {compact(d.views)} views · {d.dateLabel}
                </Muted>
              </div>
            </ClickRow>
          );
        })}
      </RowList>
      <CardHint>Based on your last 50 scheduled posts.</CardHint>
    </Card>
  );
};

export default TopPosts;
